import React from 'react'

const baseClassName = 'hero bg-silver cover flex justify-center items-center relative'

export default props => {
  const className = props.className
    ? `${baseClassName} ${props.className}`
    : baseClassName

  const overlayStyle = props.overlayStyle ? props.overlayStyle : { opacity: 0.1 }

  const content = [
    <div key='overlay' style={overlayStyle} className='absolute bg-black absolute--fill' />,
    <div key='content' className='flex flex-column w-90 w-60-ns mt5 align-center z-2'>
      {props.children}
    </div>,
  ]

  const style = {
    small: {
      backgroundPosition: 'center',
    },
    big: {
      backgroundPosition: 'center',
    },
  }

  if (props.style) {
    style.small = Object.assign(style.small, props.style.small || props.style)
    style.big = Object.assign(style.big, props.style.big || props.style)
  }

  const multipleSizeBackgrounds = style.small.backgroundImage && style.big.backgroundImage
  if (multipleSizeBackgrounds) {
    return (
      <section className={className}>
        <div className='dn-l absolute absolute--fill cover' style={style.small} />
        <div className='dn db-l absolute absolute--fill cover' style={style.big} />
        {content}
      </section>
    )
  }
  style.big.backgroundImage = props.background ? `url(${props.background})` : null

  return (
    <section className={className}
      style={style.big}
    >
      {content}
    </section>
  )
}
